const wrapperCls = "c2lw1kfscec";
const separatorCls = "c2lsa2hdnj";
const copyWrapperCls = "c2lc9sxfd6";
const copyLabelCls = "c2lc1d4n6gs";

export { copyLabelCls, copyWrapperCls, separatorCls, wrapperCls };
import "./copy-section.style.linaria.module.css";
//# sourceMappingURL=copy-section.style.js.map
